import React, { useRef } from "react";
import { useOutsideClick } from "../../helpers/util";

const YettelMenuItem = ({ yettelMenuItems }) => {
  const detailsRef = useRef();
  useOutsideClick(detailsRef);

  const circledMenu = require("./img/circled-menu.png");

  return (
    <div className="yettel-ecosystem-menu">
      <details ref={detailsRef} data-popover="down">
        <summary className="d-block pr-1 pt-1 p-0">
          <div className="ytl-icon-container"></div>
          <img className="icon" alt="circled-menu" src={circledMenu} />
        </summary>
        <div className='ytl-popover-menu-list'>
          {yettelMenuItems.map((item) => (
            <a href={item.url} className="ytl-menu-item" key={item.id} >
              <img className="ytl-menu-item-icon" alt="portal" src={require(`./img/${item.img}.png`)}/>
              <div className="ytl-menu-item-text">
                <p>{item.title}</p>
              </div>
            </a>
          ))}
        </div>
      </details>
    </div>
  )
}
export default YettelMenuItem;
